export enum ITeamAnalyticsActivityV2Enum {
  AppId = 'TeamAnalyticsActivityV2.appid',
  AverageCallInteractionDuration = 'TeamAnalyticsActivityV2.averageCallInteractionDuration',
  AverageDailyCallDuration = 'TeamAnalyticsActivityV2.averageDailyCallDuration',
  AverageDailyCallInteractions = 'TeamAnalyticsActivityV2.averageDailyCallInteractions',
  AverageDailyDuration = 'TeamAnalyticsActivityV2.averageDailyDuration',
  AverageDailyInteractions = 'TeamAnalyticsActivityV2.averageDailyInteractions',
  AverageInteractionDuration = 'TeamAnalyticsActivityV2.averageInteractionDuration',
  AverageWeeklyCallDuration = 'TeamAnalyticsActivityV2.averageWeeklyCallDuration',
  AverageWeeklyCallInteractions = 'TeamAnalyticsActivityV2.averageWeeklyCallInteractions',
  AverageWeeklyDuration = 'TeamAnalyticsActivityV2.averageWeeklyDuration',
  AverageWeeklyInteractions = 'TeamAnalyticsActivityV2.averageWeeklyInteractions',
  CallCount = 'TeamAnalyticsActivityV2.callCount',
  CallDuration = 'TeamAnalyticsActivityV2.callDuration',
  Count = 'TeamAnalyticsActivityV2.count',
  DayCount = 'TeamAnalyticsActivityV2.dayCount',
  HeatmapSegment = 'TeamAnalyticsActivityV2.heatmapsegment',
  LocalEndDate = 'TeamAnalyticsActivityV2.localenddate',
  LocalEndTime = 'TeamAnalyticsActivityV2.localendtime',
  LocalStartDate = 'TeamAnalyticsActivityV2.localStartDate',
  LocalStartTime = 'TeamAnalyticsActivityV2.localstarttime',
  LocalStartTimeDay = 'TeamAnalyticsActivityV2.localstarttime.day',
  LocalStartTimeWeek = 'TeamAnalyticsActivityV2.localstarttime.week',
  MaxDuration = 'TeamAnalyticsActivityV2.maxDuration',
  ObjectType = 'TeamAnalyticsActivityV2.objecttype',
  PerUserAvgCallCount = 'TeamAnalyticsActivityV2.perUserAvgCallCount',
  PerUserAvgCallDuration = 'TeamAnalyticsActivityV2.perUserAvgCallDuration',
  PerUserAvgCount = 'TeamAnalyticsActivityV2.perUserAvgCount',
  PerUserAvgDailyDuration = 'TeamAnalyticsActivityV2.perUserAvgDailyDuration',
  PerUserAvgDailyInteractions = 'TeamAnalyticsActivityV2.perUserAvgDailyInteractions',
  PerUserAvgDuration = 'TeamAnalyticsActivityV2.perUserAvgDuration',
  PerUserAvgWeeklyDuration = 'TeamAnalyticsActivityV2.perUserAvgWeeklyDuration',
  PerUserAvgWeeklyInteractions = 'TeamAnalyticsActivityV2.perUserAvgWeeklyInteractions',
  StartTime = 'TeamAnalyticsActivityV2.starttime',
  StartTimeDay = 'TeamAnalyticsActivityV2.starttime.day',
  SubscriptionId = 'TeamAnalyticsActivityV2.subscriptionid',
  TeamId = 'TeamAnalyticsActivityV2.teamId',
  TotalCallDuration = 'TeamAnalyticsActivityV2.totalCallDuration',
  TotalDuration = 'TeamAnalyticsActivityV2.totalDuration',
  UserCount = 'TeamAnalyticsActivityV2.userCount',
  UserId = 'TeamAnalyticsActivityV2.userid',
  WeekCount = 'TeamAnalyticsActivityV2.weekCount',
  WeekdayIndex = 'TeamAnalyticsActivityV2.weekdayindex',
  AppCategoryId = 'TeamAnalyticsActivityV2.appcategoryid',
  DepartmentId = 'TeamAnalyticsActivityV2.departmentid',
}

